// extracted by mini-css-extract-plugin
export var cancelButton = "_oi-5";
export var content = "_oi-3";
export var createButton = "_oi-6";
export var drawerContainer = "_oi-0";
export var footer = "_oi-2";
export var header = "_oi-1";
export var orderFormColumn = "_oi-4";